<template>
    <vue-basic-alert :duration="300" :closeIn="2000" ref="alert" />
    <section>
    
    <div class="register-container">
        <div class="register-form-container">
            <form id="ShopDetailForm" novalidate autocomplete="off" >
                <div class="closebtn">
                    <router-link to="/shopdashboard" class="close-btn" >X Close </router-link>
            </div>
                <div class="heading">
            <h3><b>Update Fine Rate</b></h3>
            </div>
<!--           
            <div class="row">
              
                <div class="form-group col-sm-4">
                    <label id="umarket"><b>Select Market/Street/Place:</b>
                    </label>
                    
                            <select class="form-control" @change="changemarket"  name="pradeshiya" id="pradeshiya" v-model="rentObj.market" >
                                <option value="" selected disabled>Choose</option>
                                <option v-for="ms in marketstreets" :key="ms.ms_id" :value="ms.ms_id">{{ ms.place}} </option>
                            </select>
                            <p class="error-mess" v-if="errorObj.marketErr.length > 0">{{ errorObj.marketErr[0] }}</p>
                               
                </div>
                <div class="form-group col-sm-4">
                    <label id="rentShop"><b>Select Shop Number:</b>
                    </label>
                            <select class="form-control"  name="pradeshiya" id="pradeshiya" v-model="rentObj.shop" >
                                <option value="" selected disabled>Choose</option>
                                <option v-for="sno in shopnumbers" :key="sno.shop_no" :value="sno.shop_no">{{ sno.shop_no}} </option>
                            </select>
                            <p class="error-mess" v-if="errorObj.shopErr.length > 0">{{ errorObj.shopErr[0] }}</p>
                               
                </div>
            </div> -->
     

            <div class="row">
                <div class="form-group col-sm-4">
                   <label for="fDate"> <b>Number of months to pass for calculating fines:</b>
                   </label>
                    <input type="number" name="finemonthcount" placeholder="" id="finemonthcount" class="form-control"
                        v-model="rentObj.finemonthcount" />
              </div>
                
                <div class="form-group col-sm-4">
                   <label for="fDate"> <b>The due date for calculating the fine:</b>
                   </label>
                    <input type="number" name="finedate" placeholder="fine date" id="finedate" class="form-control"
                        v-model="rentObj.finedate" />
              </div>
             <div class="form-group col-sm-4">
                   <label for="frate"> <b>Fine Rate(%):</b>
                   </label>
                    <input type="text" name="finerate" placeholder="fine rate" id="finerate" class="form-control"
                        v-model="rentObj.finerate" />
              </div>
            </div>
                <div class="form-group col-sm-6">
                    <input type="button" @click="handleSubmit" value="Update" class="btn" />
                    
                </div>
            </form>
        </div>
    </div>
</section>
<div class="Shop-container">
       <div class="Shop-form-container">
           <form id="addShopsForm"  novalidate autocomplete="off">
            <h3 style="text-align:center;"><b>Shop Details</b></h3>
            <p style="font-size: small;">* Click on arrears amount to update arrears, click on edit button for other detail updates.|හිඟ මුදල් යාවත්කාලීන කිරීම සඳහා එම කඩයට අදාළ හිඟ මුදල මත ක්ලික් කරන්න. අනෙකුත් කඩ විස්තර යාවත්කාලීන කිරීම සඳහා Edit button එක ක්ලික් කරන්න </p>
           <div class="row">
               <table id="shaptable" class="display">
               <thead>
                   <tr>   
                       <th>Index</th>
                       <th>Taxpayee name</th>
                       <th>Taxpayee NIC</th>
                       <th>Contact No</th>
                       <th>Taxpayee Address</th>
                       <th>Shop Number</th>
                       <th>Shop Place</th>
                       <th>Monthly Shop rent</th>
                       <!-- <th>other</th> -->
                       <th>Number of months<br> to pass for <br>calculating fines</th>
                        <th>Due date for calculating the fine</th>
                       <th>Fine Rate(%)</th>                      
                       <th>Last Pay<br> Month & Year</th>
                   </tr>
               </thead>
               <tbody>
                   <tr v-for=" (s,index) in allShopDetails" :key="index">

                    <td>{{  index + 1 }}</td>
                       <td style="text-align: left;">{{ s.shop_taxpayee  }}</td>
                       <td>{{ s.taxpayee_nic  }}</td>
                       <td>{{ s.  taxpayee_contact  }}</td>
                       <td style="text-align: left;">{{ s.taxpayee_address  }}</td>
                       <td>{{ s.shop_number   }}</td>
                       <td>{{  s.place }}</td>
                       <td>{{ s.monthly_shop_rent  }}</td>
                       <td>{{ s.fine_month_count  }}</td>
                       <td>{{ s.fine_date  }}</td>
                       <td>{{ s.fine_rate  }}</td>
                     
                       <td>{{  s.pay_month }}-{{  s.pay_year }}</td>
                       <!-- <td><input type="button" @click="deleteShopdetail(s.shop_details_id)" value="X" class=" btn"></td> -->
                     
                   </tr>
               </tbody>
                </table>
           <!-- <button class="fas fa-backward" @click="prevPage($event)" :disabled="currentPage === 1"></button>
             <span>{{ currentPage }} / {{ totalPages }}</span>
            <button class="fas fa-forward" @click="nextPage($event)" :disabled="currentPage === totalPages"></button> -->
           </div>
           </form>
       </div>
</div>

</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import { ref } from 'vue';
export default {
   
    name: "ShopFineupdate",
    el: '#vue-instance',
  
    data() {
        return {
            
            rentObj: { sTax:"",sTaxNic:"",sContact:"0",sAddr:"",market:"",shop:"",sRent:"",shopvotes:"",sArr:"0",sOther:"",finevote:"",mfine:"0",
                finemonthcount:"0",finedate:"0",finerate:"0.00"
            },
            errorObj: { sTaxErr: [],sTaxNic: [], sContact:[], sAddr: [],marketErr: [], shopErr: [], sRentErr: [], sOtherErr: [],arrearsErr:[],finevoteeErr:[],fineErr:[],
                finemonthcountErr:[],finedateErr:[],finerateErr:[]},
            marketstreets:[],
            shopnumbers:[],
            empshopvotes:[],
            theUser:[],
            // prs_code:null,
            distr: {
                address: {
                    ProviceVal: null,
                    
                   
            }
             },
             Prs: {
                praddress: {
                    DistVal: null,
                   
            }
             },
             allShopDetails:[],
             showPopup: false,
            
             selectedshop:'',
             
            showArrearsPopup:false,
            chosenshop:'',
            selectyr:"",
            selectmon:"",
            serverDate:'',
        }
    },

        created() {
            this.getDataFromSessionStorage()
            this.changesabha()
        },
  
        computed : {
            ...mapState(["user"]),

            filteredEmpShopVotes() {
      // Filter the empshopvotes array based on your condition
      return this.empshopvotes.filter(ratehead => ratehead.subjecttype === 'shoprent');
    },
  
},


watch: {
    allShopDetails(newData) {
      if (newData.length) {
        this.$nextTick(() => {
          this.initializeDataTable();
        });
      }
    },

    },
    methods: {
        ...mapMutations(["setUser"]),
        async getDataFromSessionStorage(){
           const data = JSON.parse(sessionStorage.getItem('userData'))
           if(data){
                           this.nic = data.nic 
                           this.sabha = data.sabha
                           this.userLevel =data.userLevel
       

                       }
           let sabhaCode = this.sabha
           
           this.allShopDetails = (await axios.get('/shopddetails/' + sabhaCode)).data
           let empvotes = await axios.get('/subheads/'+ this.nic +"/"+sabhaCode)
           this.empshopvotes = empvotes.data
           try {
                    const response = await axios.get('/getserverdate'); // Ensure correct API route
                    this.serverDate = response.data.serverDate; // Ensure correct response key
                    console.log(response.data);
                    // this.formatcurrentDate=this.getCurrentDate(this.serverDate);
                } catch (error) {
                    console.error("Error fetching server date:", error);
                }
       },

       initializeDataTable() {
            const table = $('#shaptable');
      if (!table.length) {
        console.error('Table element does not exist yet.');
        return;
      }

      if ($.fn.dataTable.isDataTable(table)) {
        table.DataTable().destroy(); // Destroy existing DataTable instance
      }
    
      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        pageLength: 25,
      lengthMenu: [10, 25, 50, 100],
      });
      const dataTableFilter = $('.dataTables_filter');
    if (dataTableFilter.length) {
        dataTableFilter.css({
        backgroundColor: '#27ae60',
        padding: '5px',
        borderRadius: '5px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            });
        }
      // Add focus/blur effects to the search input
      const searchInput = dataTableFilter.find('input');
      if (!searchInput.data('events-bound')) {
        searchInput
          .on('focus', () => {
            dataTableFilter.css('backgroundColor', '#e6f7ff'); // Brighter blue on focus
          })
          .on('blur', () => {
            dataTableFilter.css('backgroundColor', '#27ae60'); // Reset to original
          })
          .data('events-bound', true); // Mark as events bound
      }
    
},
//        nextPage(event) {
//   if (this.currentPage < this.totalPages) {
//     this.currentPage++;
//   }
//   // Prevent default form submission behavior
//   event.preventDefault();
// },
// prevPage(event) {
//   if (this.currentPage > 1) {
//     this.currentPage--;
//   }
//   // Prevent default form submission behavior
//   event.preventDefault();
// },
    
       async changesabha() {    
            let marketData = (await axios.get('/marketstreet/' + this.sabha));
            this.marketstreets=marketData.data; 
       },
       async changemarket() {    
            let shopno = (await axios.get('/marketstreetbyid/'+ this.sabha +'/'+ this.rentObj.market));
            this.shopnumbers=shopno.data; 
       },
       async deleteShopdetail(shop_details_id){
        await axios.delete("/deletshopdetail/" +  shop_details_id );
        this.$refs.alert.showAlert('success', 'Shop details Deleted Successfully !')
        this.allShopDetails = (await axios.get('/shopddetails/' + this.sabha)).data
       },



            resetCheckErr: function () {
           
            this.errorObj.finemonthcountErr=[];
            this.errorObj.finedateErr=[];
            this.errorObj.finerateErr=[]
        },
        resetObjects: function(){
            
            this.rentObj.finemonthcount="0"
            this.rentObj.finedate="0"
            this.rentObj.finerate="0.00"
        },
        checkEmptyErr: function () {
            for (var typeErr in this.errorObj) {
                if (this.errorObj[typeErr].length != 0) {
                    return false;
                }
            }
            return true;
        },
         checkForm: function () {
            this.resetCheckErr();

            if (!this.rentObj.finedate>0) {
                this.errorObj.finedateErr.push("The due date is required");
            }
            if (!this.rentObj.finerate>0) {
                this.errorObj.finerateErr.push("Fine rate is required");
            }
            if (!this.rentObj.finemonthcount>0) {
                this.errorObj.finemonthcountErr.push("Number of months to pass is required");
            }

           
        },
     
       async handleSubmit(e) {
        try {
           this.checkForm();
           
                if (!this.checkEmptyErr()) {
                    e.preventDefault();
                } else {
                 e.preventDefault();
               
                    if(!this.user){
                        this.$refs.alert.showAlert('error','Please Loging to Continue !')
                    }
                    else{
                    
                     const data = {

                        fine_month_count:this.rentObj.finemonthcount,
                        fine_rate:this.rentObj.finerate,
                        fine_date:this.rentObj.finedate
                        
                    }
                    // sessionStorage.setItem('rentDetails',JSON.stringify(data));this.sabha
                   await axios.put("/updatesabhashopdata/"+this.sabha,data);
                    
                    document.getElementById("ShopDetailForm").reset();
                    this.allShopDetails = (await axios.get('/shopddetails/' + this.sabha)).data
                    //  this.$refs.alert.showAlert('success', 'Successfully Updated!');
      
                }
            }
        } catch (error) {
            console.error('Error in Update Shop Fine Rate data:', error);
            this.$refs.alert.showAlert('error', 'Failed to Update Shop Fine Rate!');
         }
            
        }
        
        
      
    },
    components: {
        VueBasicAlert
    }
}

</script>





<style scoped>
.closebtn{
    align-content: baseline;
}
.close-btn {
/* align-items: right; */
background-color:rgb(121, 23, 12);
border: none;
font-size: 15px;
font-weight: bold;
cursor: pointer;
color: #f8f4f4;
transition: color 0.3s ease, transform 0.2s ease;
padding: 8px;
border-radius: 8px;
width:6%;
height: 4%;
text-align: center;
}
.register-container {
    padding: 1rem 1%;
   
}

.register-container .register-form-container {
    background: #fff;

}

.register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    /* max-width: 98rem; */
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 2rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
}

.register-container .register-form-container form h3 {
    padding-bottom: 0.5rem;
    font-size: 1.9rem;
    text-transform: uppercase;
    color: #130f40;
    /* margin: 0; */
    text-align: center;
    
}

.register-container .register-form-container form .form-control {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    background: #f7f7f7;
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 100%;
    border: margin-bottom; 
}

.register-container .register-form-container form .form-control1 {
    margin: 0.7rem 0;
    border-radius: 0.5rem;
    background: #f7f7f7;
    /* padding: 2rem 1.2rem; */
    font-size: 1.5rem;
    color: #130f40;
    text-transform: none;
    width: 40%;
    border: none;
    padding-bottom: 0.5rem;
}
.register-container .register-form-container form .form-radio {
    margin: 2rem 0%;
    border-radius: 0.5rem;
    background: #f7f7f7;
   padding-bottom: 1rem;
    font-size: 10rem;
    color: #130f40;

    width: 10%;
    border: none;
    margin-left: 10%;
}
.register-container .register-form-container form label {
    font-size: 1.5rem;
    margin: 0;
    padding: 0;
}

.register-container .register-form-container form span {
    font-size: 25px;
    /* padding-left: 5px;
    padding-right: 40px; */
    text-align: center;
    color: #620a0a;

}

.register-container .register-form-container form .btn {
    margin: 1rem 0;
    width: 30%;
    text-align: center;
    align-items: center;
    /* background: #620a0a; */
    background-color : #5a0303;
    
}

.register-container .register-form-container form p {
    padding-top: 0.75rem;
    font-size: 1rem;
    color: #666;
    margin: 0;
}

.register-container .register-form-container form p a {
    color: #27ae60;
}

.register-container .register-form-container form p a:hover {
    color: #130f40;
    text-decoration: underline;
}

.register-container .register-form-container form .form-group  {
    margin: 0;
}

.register-container .register-form-container form .form-group  .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 0;
    padding: 0;
    width: 90%;

} 
.register-container .register-form-container form .hide {
    display: none;

} 
/* for second container */
.Shop-container {
   background-color: #ffffff09;
   /* height: 50vh; */
   padding: 1rem 1%;
   font-size: 16px;
}



/* ongoing */
.Shop-container .Shop-form-container {
   background: #fff;
   width: 100% !important;
   
}

.Shop-container .Shop-form-container form {
   /* position: relative;
   left: 40%;
   transform: translate(-50%, 0%); */
   /* max-width: 70rem; */
   width: 100%;
   box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
   border: 0.1rem solid rgba(0, 0, 0, 0.2);
   padding: 3rem;
   border-radius: 0.5rem;
   animation: fadeUp 0.4s linear;
   
}

.Shop-container .Shop-form-container form h3 {
   padding-bottom: 1rem;
   font-size: 2rem;
   text-transform: uppercase;
   color: #130f40;
   margin: 0;
}

.Shop-container .Shop-form-container form .form-control {
    margin: 0.7rem 0;
   border-radius: 0.5rem;
   background: #f7f7f7;
   /* padding: 2rem 1.2rem; */
    font-size: 1.3rem; 
   color: #130f40;
   text-transform: none;
   width: 100%;
   border: margin-bottom; 
} 

.Shop-container .Shop-form-container form label {
    font-size: 1.2rem;
   margin: 0;
   padding: 0;
   float:left;
}

.Shop-container .Shop-form-container form span {
   font-size: 18px;
   padding-left: 5px;
   padding-right: 40px;
}

.Shop-container .Shop-form-container form .btn {
   margin: 1rem 0;
   width: 100%;
   text-align: center;
   font-size: small;
   background-color : #af74a7;
    height: 3rem;
  
   
}
/* .Shop-container .Shop-form-container form .table {
   margin: 1rem 0;
   width: 100%;
   text-align: center;
   font-size: small;
   background-color : #e9e4e9;
    height: 3rem;
   
} */
.Shop-container .Shop-form-container form .Addbtn {
   /* margin: 1rem 0; */
   width: 5rem;
   /* height: 2rem; */
   /* text-align: center; */
   /* background-color : #af74a7; */
   /* vertical-align: bottom; */
   /* align-items: bottom; */
   padding-top: 1.9rem;
   padding-left: 3rem;
   
}

.Shop-container .Shop-form-container form p {
   padding-top: 1rem;
   font-size: 1.5rem;
   color: rgb(22, 21, 21);
   margin: 0;
}

.Shop-container .Shop-form-container form p a {
   color: #27ae60;
}

.Shop-container .Shop-form-container form p a:hover {
   color: #130f40;
   text-decoration: underline;
}

.Shop-container .Shop-form-container form .form-group {
   margin: 0;
}

.Shop-container .Shop-form-container form .form-group .error-mess {
   font-size: 1.5rem;
   position: relative;
   color: rgb(243, 47, 47);
   margin: 0;
   padding: 2rem 1.2rem;
}
/* .project-list>tbody>tr>td {
   padding: 12px 8px;
}

.project-list>tbody>tr>td .avatar {
   width: 22px;
   border: 1px solid #CCC;
} */
/* [popup] */
.popup-button {
      padding: 10px 20px;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
  }

  .modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
  }

  .modal-content {
      background-color: white;
      padding: 5px;
      border-radius: 1px;
      /* max-width: 500px; */
      width: 60%;
      position: relative;
  }

  .close x {
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 5px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 18px;
      color: #555;
  }

  .close-x:hover {
      color: #ff0000;
      /* Change to your desired hover color */
  }


  .modal-header {
      padding-bottom: 2px;
      border-bottom: 1px solid #ccc;
  }

  .modal-body {
      /* padding: 10px 20px 20px 20px; */
      padding-left: 5%; 

  }
  .model-group {
      padding: 10px ;
      /* padding-left: 10%;
      padding-right: 10%;
      padding-bottom: 10%; */
      /* margin: 10px; */
      /* justify-content: left; */
      margin-right: 10px;
  }
  .modal-body.model-group .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 10%;
    padding: 0;
    width: 90%;

} 
.modal-body.row {
    display: flex;
    margin: 10%;
  }
  .modal-footer {
      padding-top: 5px;
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: flex-end;
  }

  .close-button,
  .save-button {
      padding: 5px 10px;
      border: none;
      cursor: pointer;
      font-weight: bold;
      border-radius: 4px;
      transition: background-color 0.3s ease;
  }

  .close-button {
      background-color: #f44336;
      color: white;
  }

  .save-button {
      background-color: #4CAF50;
      color: white;
      margin-left: 5px;
  }

  .close-button:hover {
      background-color: #d32f2f;
  }

  .save-button:hover {
      background-color: #45a049;
  }
  /* 2 */
  .modal-body2 {
      /* padding: 10px 20px 20px 20px; */
      padding-left:1.0rem; 

  }
  .modal-content2 {
      background-color: white;
      padding: 5px;
      border-radius: 1px;
      /* max-width: 500px; */
      width: 30%;
      position: relative;
  }
  .model-group2 {
      /* padding: 10px ; */
      padding-left: 10%;
      padding-right: 10%;
      padding-bottom: 10%; 
      /* margin: 10px; */
      justify-content:center;
      margin-right: 10px;
  }
  .modal-footer2 {
      padding-top: 5px;
      border-top: 1px solid #ccc;
      display: flex;
      justify-content: flex-end;
  }
  .close-x2 {
      /* position: absolute; */
      top: 5px;
      right: 5px;
      left: 5px;
      padding: 5px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 15px;
      color: #555;
  }
  .modal-body2 .model-group2 .error-mess {
    font-size: 1rem;
    position: relative;
    color: rgb(243, 47, 47);
    margin: 10%;
    padding: 0;
    width: 90%;

} 
#shaptable {
   width: 100%; 
  text-align: center; 
  font-size: 1.2rem;; 
  border-width: 1px; 
  border-style: solid; 
  border-color: #130f40; 
  border-collapse: collapse; 
  /* margin-left: auto;  */
  /* margin-right: auto; */
  /* table-layout: fixed;  */
}

#shaptable thead  th {
  background-color: #f4f4f4;
  color: #333;
  font-weight: bold;
  /* padding: 10px; */
  /* width: auto; */
  font-size: 1.2rem; 
}
#shaptable th:nth-child(1), #shaptable td:nth-child(1) { /* First column */
  width: 3%;  /* shaptable fixed width */
  
}

#shaptable th:nth-child(2), #shaptable td:nth-child(2) { /* Second column */
  width: 18%;  /* shaptable fixed width */
}

#shaptable th:nth-child(3), #shaptable td:nth-child(3) { /* Third column */
  width: 10%;  /* shaptable fixed width */
}
#shaptable th:nth-child(4), #shaptable td:nth-child(4) { /* Third column */
  width: 10%;  /* shaptable fixed width */
}
#shaptable th:nth-child(5), #shaptable td:nth-child(5) { /* Third column */
  width: 14%;  /* shaptable fixed width */
}
#shaptable th:nth-child(6), #shaptable td:nth-child(6) { /* Third column */
  width: 6%;  /* shaptable fixed width */
}
#shaptable th:nth-child(7), #shaptable td:nth-child(7) { /* Third column */
  width: 16%;  /* shaptable fixed width */
}
#shaptable th:nth-child(8), #shaptable td:nth-child(8) { /* Third column */
  width: 6%;  /* shaptable fixed width */
}
#shaptable th:nth-child(9), #shaptable td:nth-child(9) { /* Third column */
  width: 4%;  /* shaptable fixed width */
}
#shaptable th:nth-child(10), #shaptable td:nth-child(10) { /* Third column */
  width: 4%;  /* shaptable fixed width */
}
#shaptable th:nth-child(11), #shaptable td:nth-child(11) { /* Third column */
  width: 4%;  /* shaptable fixed width */
}
#shaptable th:nth-child(12), #shaptable td:nth-child(12) { /* Third column */
  
    width: 5%;  /* shaptable fixed width */
}

#shaptable tbody tr {
  background-color: #fff;
}

#shaptable tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>
